import firebase from '../config/firebase';
import shipperService from './shipper.service';

const db = firebase.firestore();

const userService = {

    async getUsers() {
        try {
            const snapshot = await db.collection('user_web').get();
            const users = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            return users;
        }
        catch (error) {
            console.error("Error getting documents: ", error);
            throw error;
        }
    },

    async updateUser(userId, userData) {
        try {
            await db.collection('user_web').doc(userId).update(userData);
        }
        catch (error) {
            console.error("Error updating document: ", error);
            throw error;
        }
    },

    async updateUserPerfil(perfil, permissions, selecionarTodosGeral) {
        try {
            const snapshot = await db.collection('user_web')
                .where('perfil', '==', perfil)
                .get();

            if (snapshot.empty) {
                console.log("Nenhum usuário encontrado com esse perfil.");
                return;
            }

            // Usa batch para fazer tudo de uma vez (melhor performance)
            const batch = db.batch();

            snapshot.docs.forEach(doc => {
                const userRef = db.collection('user_web').doc(doc.id);
                batch.update(userRef, { permissoes: permissions, permissoesAll: selecionarTodosGeral });
            });

            await batch.commit();
            console.log("Permissões atualizadas com sucesso para todos os usuários do perfil:", perfil);
        } catch (error) {
            console.error("Erro ao atualizar documentos:", error);
            throw error;
        }
    },


    /**
     * Retorna uma lista de usuários associados com o Fortio.
     * 
     * @param {string} userId - ID do usuário atual
     * @returns {object[]} - uma lista de objetos que contém o ID e o nome dos usuários associados com o Fortio
     * @throws {Error} - lança um erro se ocorrer algum problema durante a execução da função
     */
    async usersAssociatedWithFortio() {
        try {
            const resultShipper = await shipperService.getShipperbyPrincipal();

            const result = await db.collection("user_web")
            .where("uidShipper", "==", resultShipper.id)
            .get();
            
            const list = result.docs.map(doc => ({
                id: doc.id,
                name: doc.data().name,
                email: doc.data().email || "",
                phoneNumber: doc.data().phoneNumber || "",
                phoneNumberFirst: doc.data().phoneNumberFirst || "",
                phone: doc.data().phone || "",
                telefone: doc.data().telefone || "",
            }));

            return list;
        }
        catch (error) {
            console.error("Error deleting document: ", error);
            throw error;
        }
    }
}

export default userService;